// Replace with your Mapbox access token
const MAPBOX_TOKEN = 'pk.eyJ1IjoiY3VzdG9tY3VmZiIsImEiOiJja2FrczA0cXAwbmM2MnR0ZGR1dnljdGx0In0._EkFqlWTPsGRXyxeRebiYg';
// https://api.mapbox.com/geocoding/v5/mapbox.places-permanent/mum.json?limit=5&proximity=115.13830000000007%2C-8.3692&language=en-US&access_token=

// Utility function to convert decimal degrees to DMS format
function decimalToDMS(decimal, isLatitude = true) {
    const absolute = Math.abs(decimal);
    const degrees = Math.floor(absolute);
    const minutesNotTruncated = (absolute - degrees) * 60;
    const minutes = Math.floor(minutesNotTruncated);
    const seconds = ((minutesNotTruncated - minutes) * 60).toFixed(2);
    
    const direction = isLatitude 
        ? (decimal >= 0 ? 'N' : 'S')
        : (decimal >= 0 ? 'E' : 'W');
    
    return `${degrees}°${minutes}'${seconds}"${direction}`;
}


class LocationSearcher {
    constructor() {
        this.input = document.getElementById('location-input');
        this.findButton = document.getElementById('find-button');
        this.suggestions = document.getElementById('suggestions');
        this.selectedLocation = document.getElementById('selected-location');
        this.errorMessage = document.getElementById('error-message');
        
        this.debounceTimer = null;
        this.currentQuery = '';
        
        this.init();
    }
    
    init() {
        // Event listeners
        this.input.addEventListener('input', (e) => this.handleInput(e));
        this.input.addEventListener('keydown', (e) => this.handleKeydown(e));
        this.findButton.addEventListener('click', () => this.handleFind());
        
        // Click outside to close suggestions
        document.addEventListener('click', (e) => {
            if (!e.target.closest('.search-container')) {
                this.hideSuggestions();
            }
        });
        
        this.clearError();
    }
    
    handleInput(e) {
        const query = e.target.value.trim();
        this.currentQuery = query;
        
        clearTimeout(this.debounceTimer);
        
        if (query.length < 2) {
            this.hideSuggestions();
            this.hideErrorMessage();
            return;
        }
        
        this.debounceTimer = setTimeout(() => {
            if (this.currentQuery === query) {
                this.searchLocations(query);
            }
        }, 300);
    }
    
    handleKeydown(e) {
        if (e.key === 'Enter') {
            e.preventDefault();
            this.handleFind();
        } else if (e.key === 'Escape') {
            this.hideSuggestions();
        }
    }
    
    handleFind() {
        const query = this.input.value.trim();
        if (query) {
            this.searchLocations(query, true);
        }
    }
    
    async searchLocations(query, selectFirst = false) {
        try {
            this.clearError();
            this.showLoading();
            
            const response = await fetch(
                `https://api.mapbox.com/geocoding/v5/mapbox.places/${encodeURIComponent(query)}.json?access_token=${MAPBOX_TOKEN}&limit=5&autocomplete=true`
            );
            
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            
            const data = await response.json();
            
            if (selectFirst && data.features.length > 0) {
                this.selectLocation(data.features[0]);
                this.hideSuggestions();
            } else {
                this.showSuggestions(data.features);
            }
            
        } catch (error) {
            console.error('Search error:', error);
            this.showError('Search failed. Please check your internet connection and try again.');
            this.hideSuggestions();
        }
    }
    
    showLoading() {
        this.suggestions.innerHTML = '<div class="loading">🔍 Searching...</div>';
        this.suggestions.style.display = 'block';
    }
    
    showSuggestions(features) {
        if (features.length === 0) {
            this.suggestions.innerHTML = '<div class="no-results">No locations found</div>';
            this.suggestions.style.display = 'block';
            return;
        }
        
        const suggestionsHTML = features.map(feature => {
            const placeName = feature.place_name;
            const context = feature.context || [];
            const placeType = feature.place_type?.[0] || 'place';
            
            // Extract main name and address
            const parts = placeName.split(',');
            const mainName = parts[0];
            const address = parts.slice(1).join(',').trim();
            
            return `
                <div class="suggestion-item" data-feature='${JSON.stringify(feature)}'>
                    <div class="suggestion-text">
                        <div class="suggestion-name">${mainName}</div>
                        ${address ? `<div class="suggestion-address">${address}</div>` : ''}
                    </div>
                </div>
            `;
        }).join('');
        
        this.suggestions.innerHTML = suggestionsHTML;
        this.suggestions.style.display = 'block';
        this.hideErrorMessage();
        
        // Add click listeners
        this.suggestions.querySelectorAll('.suggestion-item').forEach(item => {
            item.addEventListener('click', () => {
                const feature = JSON.parse(item.dataset.feature);
                this.selectLocation(feature);
                this.hideSuggestions();
            });
        });
    }
    
    hideSuggestions() {
        this.suggestions.style.display = 'none';
    }

    hideErrorMessage() {
        this.errorMessage.style.display = 'none';
    }
    
    selectLocation(feature) {
        const coordinates = feature.center; // [longitude, latitude]
        const lat = coordinates[1];
        const lon = coordinates[0];
        const name = feature.place_name;
        
        // Convert to DMS format
        const latDMS = decimalToDMS(lat, true);
        const lonDMS = decimalToDMS(lon, false);
        
        // Update input
        this.input.value = name;
        console.log(name, lat, lon);
        console.log('DMS format:', latDMS, lonDMS);

        document.querySelector('#coordinates-latitude').value = latDMS; 
        document.querySelector('#coordinates-longitude').value = lonDMS;

        // Callback for integration with other apps
        this.onLocationSelected({
            name: name,
            latitude: lat,
            longitude: lon,
            latitudeDMS: latDMS,
            longitudeDMS: lonDMS,
            coordinates: coordinates,
            feature: feature
        });
        
        this.clearError();
    }
    
    onLocationSelected(location) {
        // Override this method or add event listener for integration
        console.log('Location selected:', location);
        // Custom event for integration
        window.dispatchEvent(new CustomEvent('locationSelected', {
            detail: location
        }));
    }
    
    showError(message) {
        this.errorMessage.innerHTML = `<div class="error-message">${message}</div>`;
        this.errorMessage.style.display = 'block';
        this.hideSuggestions();
    }
    
    clearError() {
        this.errorMessage.innerHTML = '';
    }
}

// Utility function to copy text to clipboard
function copyToClipboard(elementId) {
    const element = document.getElementById(elementId);
    const text = element.textContent;
    
    navigator.clipboard.writeText(text).then(() => {
        // Show feedback
        const originalText = element.textContent;
        element.textContent = 'Copied!';
        element.style.background = '#48bb78';
        element.style.color = 'white';
        
        setTimeout(() => {
            element.textContent = originalText;
            element.style.background = 'white';
            element.style.color = '#333';
        }, 1000);
    }).catch(err => {
        console.error('Failed to copy: ', err);
    });
}

// Initialize the location searcher
const locationSearcher = new LocationSearcher();

// Listen for location selection events
window.addEventListener('locationSelected', (event) => {
    const location = event.detail;
    console.log('Location event received:', location);
    // Add your custom integration code here
});